/**
 * Responsibility: Implement common behavior for the engine layer.
 * Scope: Owns engine-layer concerns only; cross-layer orchestration is excluded.
 */
import type { GameState, InventoryItem } from "@anyquest/shared-core"
import type { SupervisorCheckResult, SupervisorIncidentSeed } from "@anyquest/shared-core"

export function failed(incidents: SupervisorIncidentSeed[]): SupervisorCheckResult {
  return { passed: incidents.length === 0, incidents }
}

export function locationKey(state: GameState): string {
  return `${state.player.location.x}_${state.player.location.y}_${state.player.location.z ?? 0}`
}

export function countInvalidInventoryItems(items: InventoryItem[] | undefined): number {
  if (!Array.isArray(items)) return 1
  let invalid = 0
  for (const item of items) {
    const name = String(item?.name ?? '').trim()
    if (!name || typeof item?.equipped !== 'boolean') invalid += 1
  }
  return invalid
}

export function findDuplicateNames(names: string[]): string[] {
  const seen = new Set<string>()
  const dup = new Set<string>()
  for (const raw of names) {
    const key = raw.trim().toLowerCase()
    if (!key) continue
    if (seen.has(key)) dup.add(key)
    else seen.add(key)
  }
  return [...dup]
}

export function asFiniteNumber(value: unknown, fallback: number): number {
  const n = Number(value)
  return Number.isFinite(n) ? n : fallback
}
